/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerResponse } from './';
import {
    FreelancerResponseFromJSON,
    FreelancerResponseFromJSONTyped,
    FreelancerResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferredFreelancerResponse
 */
export interface ReferredFreelancerResponse {
    /**
     * 
     * @type {FreelancerResponse}
     * @memberof ReferredFreelancerResponse
     */
    identifiedFreelancer?: FreelancerResponse;
    /**
     * 
     * @type {string}
     * @memberof ReferredFreelancerResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferredFreelancerResponse
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferredFreelancerResponse
     */
    lastname?: string;
}

/**
 * Check if a given object implements the ReferredFreelancerResponse interface.
 */
export function instanceOfReferredFreelancerResponse(value: object): value is ReferredFreelancerResponse {
    return true;
}

export function ReferredFreelancerResponseFromJSON(json: any): ReferredFreelancerResponse {
    return ReferredFreelancerResponseFromJSONTyped(json, false);
}

export function ReferredFreelancerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredFreelancerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'identifiedFreelancer': json['identifiedFreelancer'] == null ? undefined : FreelancerResponseFromJSON(json['identifiedFreelancer']),
        'email': json['email'] == null ? undefined : json['email'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
    };
}

export function ReferredFreelancerResponseToJSON(value?: ReferredFreelancerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identifiedFreelancer': FreelancerResponseToJSON(value['identifiedFreelancer']),
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

